import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { sidebarNavigation, SidebarNavigationItem } from '../../../../../utils/sidebarNavigation';
import { useAppSelector } from '@app/hooks/reduxHooks';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
}

const sidebarNavFlat = sidebarNavigation.reduce(
  (result: SidebarNavigationItem[], current) =>
    result.concat(current.children && current.children.length > 0 ? current.children : current),
  [],
);

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentMenuItem = sidebarNavFlat.find(({ url }) => url === location.pathname);
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = sidebarNavigation.find(({ children }) =>
    children?.some(({ url }) => url === location.pathname),
  );

  //if role super admin show all
  sidebarNavigation.forEach((nav) => {
    if (nav.key !== 'dashboard') {
      nav.render = false;
      nav.children?.forEach((child) => {
        child.render = false;
      });
    }
  });
  const allowedpages = useAppSelector((state) => state.user.user?.AllowedPages);
  // show respective assigned pages
  allowedpages?.forEach((item) => {
    sidebarNavigation.forEach((nav) => {
      if (nav.key === item) {
        nav.render = true;
      }

      if (nav.children?.some(({ key }) => key === item)) {
        nav.render = true;
        nav.children?.forEach((element) => {
          if (element.key === item) {
            element.render = true;
          }
        });
      }
    });
  });

  const defaultOpenKeys = openedSubmenu ? [openedSubmenu.key] : [];

  return (
    <S.Menu
      mode="inline"
      defaultSelectedKeys={defaultSelectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      onClick={() => setCollapsed(true)}
      items={sidebarNavigation
        .filter((x) => x.render === true)
        .map((nav) => {
          const isSubMenu = nav.children?.length;

          return {
            key: nav.key,
            title: t(nav.title),
            label: isSubMenu ? t(nav.title) : <Link to={nav.url || ''}>{t(nav.title)}</Link>,
            icon: nav.icon,
            children:
              isSubMenu &&
              nav.children &&
              nav.children
                .filter((x) => x.render === true)
                .map((childNav) => ({
                  key: childNav.key,
                  label: <Link to={childNav.url || ''}>{t(childNav.title)}</Link>,
                  title: t(childNav.title),
                  icon: childNav.icon,
                })),
          };
        })}
    />
  );
};

export default SiderMenu;
